import { parseHttpError, requestJson } from './http';

export interface AuthSession {
  username: string;
  expires_at: number;
  expires_in: number;
}

export async function getSession(allowAnonymous = false): Promise<AuthSession> {
  if (!allowAnonymous) return requestJson('/auth/session');
  const response = await fetch('/auth/session', { credentials: 'same-origin', cache: 'no-store' });
  if (!response.ok) throw new Error('登录状态已失效');
  return response.json() as Promise<AuthSession>;
}
export async function login(username: string, password: string): Promise<{ username: string }> {
  const response = await fetch('/auth/login', {
    method: 'POST', credentials: 'same-origin', cache: 'no-store',
    headers: { 'Content-Type': 'application/json', 'X-ChanHub-Request': '1' },
    body: JSON.stringify({ username, password }),
  });
  if (!response.ok) throw await parseHttpError(response);
  return response.json() as Promise<{ username: string }>;
}
export const logout = (): Promise<void> => requestJson('/auth/logout', { method: 'POST', body: '{}' });
export const changePassword = (current_password: string, new_password: string): Promise<{ changed: boolean }> =>
  requestJson('/auth/password', { method: 'POST', body: JSON.stringify({ current_password, new_password }) });

export function safeReturnPath(value: string | null): string {
  if (!value || !value.startsWith('/') || value.startsWith('//')) return '/structure-v2';
  try {
    const parsed = new URL(value, window.location.origin);
    return parsed.origin === window.location.origin ? `${parsed.pathname}${parsed.search}${parsed.hash}` : '/structure-v2';
  } catch {
    return '/structure-v2';
  }
}

export function broadcastAuthChange(): void {
  try { localStorage.setItem('chanhub-auth-event', String(Date.now())); } catch { /* storage can be disabled */ }
}
